import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import { Button, SelectButton, TextButton, IconType, ButtonType } from '@checkmarx/cx-ui';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import PortalTextBox from '../../portal/portalTextBox';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import { formatCertificateFileName } from '../../../services/formatters/certificateFileNameFormatter';
import styles from './style.scss';
const fileDownload = require('js-file-download');

@inject('translationsStore', 'samlServiceProviderStore') @observer
export default class ServiceProviderForm extends Component {

    errorDialogTitle;
    errorDialogMessage;

    state = {
        openErrorDialog: false
    };

    componentDidMount() {

        this.props.samlServiceProviderStore.reset();
        this.get();
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }
   
    triggerToastr = (message, level) => {

        ToastrService.triggerToastr({level, message});
    }

    handleFiles = e => {

        this.props.samlServiceProviderStore.setCertificateFileName(e.target.files[0].name);
        this.props.samlServiceProviderStore.setCertificateFile(e.target.files[0]);
        this.props.samlServiceProviderStore.setCertificateSubject('');
    }

    handleChangeCertificatePassword = e => this.props.samlServiceProviderStore.setCertificatePassword(e.target.value);

    handleChangeIssuer = e => this.props.samlServiceProviderStore.setIssuer(e.target.value);
    handleBlurIssuer = e => this.props.samlServiceProviderStore.validateIssuer()

    get = _ => {

        this.props.samlServiceProviderStore.get()
        .then(sp => {

            this.props.samlServiceProviderStore.setIssuer(sp.issuer);
            this.props.samlServiceProviderStore.setCertificateFileName(sp.certificateFileName);
            this.props.samlServiceProviderStore.setCertificateSubject(sp.certificateSubject);
        })
        .catch(err => {

            this.errorDialogMessage = this.props.samlServiceProviderStore.getSAMLServiceProviderErrorMessage;
            this.errorDialogTitle = this.props.translationsStore.translate('ERROR');
            this.openErrorDialog();
        });     
    }

    put = _ => {

        const isValid = this.props.samlServiceProviderStore.validateForm();

        if (isValid === false) {
            
            return;
        }

        this.props.samlServiceProviderStore.put()
            .then(_ => {
                
                const level = ToastrLevelsEnum.SUCCESS;
                const message = this.props.translationsStore.translate('SAML_SP_UPDATED_SUCCESS_MESSAGE');
                this.triggerToastr(message, level);

                this.get();
            })
            .catch(err => {

                this.errorDialogMessage = this.props.samlServiceProviderStore.putSAMLServiceProviderErrorMessage;
                this.errorDialogTitle = this.props.translationsStore.translate('ERROR');
                this.openErrorDialog();
            });
    }

    downloadMetadata = _ => {

        this.props.samlServiceProviderStore.getMetadata()
            .then(metadata => {

                fileDownload(metadata, 'Cx_SAML_Metadata.xml');
            })
            .catch(err => {

                this.errorDialogMessage = this.props.samlServiceProviderStore.getMetadataErrorMessage;
                this.errorDialogTitle = this.props.translationsStore.translate('ERROR');
                this.openErrorDialog();
            });
    }

    render() {

        const certificateFileName = formatCertificateFileName(
                this.props.samlServiceProviderStore.certificateFileName,
                this.props.samlServiceProviderStore.certificateSubject
            );

        return(
            <div>
                <div className={styles.samlServiceProviderForm}>
                    <SelectButton
                        dataCy='sp-certificate-fileuploader'
                        placeHolderText={this.props.translationsStore.translate('SP_CERTIFICATE_FILE')}
                        width='47%'
                        style={{top: '10px'}}
                        buttonText={this.props.translationsStore.translate('BROWSE')}
                        isFileInput
                        fileInputAccept='.pfx,.p12'
                        fileInputChange={this.handleFiles}
                        title={certificateFileName}
                        value={certificateFileName}
                        helpTooltipText={this.props.translationsStore.translate('PFX_CERTIFICATION_FILE_TOOLTIP')}
                    />
                    <PortalTextBox
                        dataCy={'txt-sp-certificate-password'}
                        hintText={this.props.translationsStore.translate('PASSWORD')}
                        floatingLabelText={this.props.translationsStore.translate('PASSWORD')}
                        width='47%'
                        type='password'
                        onChange={this.handleChangeCertificatePassword}
                        value={this.props.samlServiceProviderStore.certificatePassword || ''}
                    />
                    <PortalTextBox
                        dataCy={'txt-sp-issuer'}
                        hintText={this.props.translationsStore.translate('ISSUER_SERVICE_PROVIDER')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('ISSUER_SERVICE_PROVIDER')} 
                                                required={true} />}
                        width='47%'
                        onChange={this.handleChangeIssuer}
                        onBlur={this.handleBlurIssuer}
                        errorText={this.props.samlServiceProviderStore.issuerValidationMessage}
                        value={this.props.samlServiceProviderStore.issuer || ''}
                        helpTooltipText={this.props.translationsStore.translate('ISSUER_SERVICE_PROVIDER_TOOLTIP')}
                    />
                </div>

                <div className={styles.samlDownloadMetadata}>
                    <TextButton
                        dataCy='download-metadata'
                        text={this.props.translationsStore.translate('DOWNLOAD_METADATA')}
                        iconType={IconType.download}
                        onClick={this.downloadMetadata} />
                </div>

                <div className={styles.samlUpdateServiceProviderButtonWrapper}>    
                    <div className={styles.samlUpdateServiceProviderButton}>            
                        <Button
                            dataCy='update-button' 
                            inProgress={this.props.samlServiceProviderStore.putSAMLServiceProviderProgress}
                            text={this.props.translationsStore.translate('SAVE')}
                            onClick={this.put}
                        >
                        </Button>
                    </div>
                </div>

                <ErrorDialog
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.errorDialogTitle}
                    contentText={this.errorDialogMessage}
                />
            </div>
        );
    }
}